import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";


const EmployeeView = ({ Emp_data }) => {

    const [Data, setData] = useState({
        blood_group: "",
        con_person: "",
        cont_no: "",
        date_of_birth: "",
        department: "",
        doj: "",
        emp_type: "",
        incharge: "",
        location: "",
        mobile: "",
        name: "",
        password: "",
        relationship: "",
        salary: "",
        shift_in: "",
        shift_out: "",
        status: "",
        stay: "",
        user_type: ""
    })

    useEffect(() => {
        setData({
            blood_group: Emp_data.blood_group,
            con_person: Emp_data.emergency_con_person,
            cont_no: Emp_data.emergency_con_number,
            date_of_birth: Emp_data.dob,
            department: Emp_data.department,
            doj: Emp_data.doj,
            emp_type: Emp_data.emp_type,
            incharge: Emp_data.incharge,
            location: Emp_data.location,
            mobile: Emp_data.mobile,
            name: Emp_data.name,
            password: Emp_data.password,
            relationship: Emp_data.relationship,
            salary: Emp_data.salary,
            shift_in: Emp_data.shift_intime,
            shift_out: Emp_data.shift_outtime,
            status: Emp_data.status,
            stay: Emp_data.stay,
            user_type: Emp_data.user_type
        })
    }, [Emp_data])

    function formatSimpleDate(dateStr) {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }


// function formatTimeTo12Hour(time24) {
//   if (typeof time24 !== 'string' || !time24.includes(":")) {
//     return ""; // or return a fallback like "Invalid time"
//   }

//   const [hourStr, minuteStr] = time24.split(":");
//   const hour = parseInt(hourStr, 10);
//   const minute = parseInt(minuteStr, 10);

//   if (isNaN(hour) || isNaN(minute)) {
//     console.warn("Invalid numeric values in time:", time24);
//     return "";
//   }

//   const isPM = hour >= 12;
//   const period = isPM ? "pm" : "am";

//   const hour12 = hour % 12 === 0 ? 12 : hour % 12;
//   const minuteFormatted = minute < 10 ? `0${minute}` : minute;

//   return `${hour12}:${minuteFormatted}${period}`;
// }


    return (
        <div
            className="modal custom-modal custom-lg-modal fade p-20"
            id="employee-view"
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <div className="form-header modal-header-title text-start d-flex align-items-center mb-0">
                            <h4 className="mb-0">Employee Details</h4>
                        </div>
                        <button
                            type="button"
                            className="btn-close ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body pb-0">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-field-item">
                                    <div className="profile-picture company-detail-head">
                                        <div className="upload-profile">
                                            <div className="add-profile">
                                                <p>Status</p>
                                            </div>
                                        </div>
                                        <div>
                                            {Data.status == 1 &&
                                                <span className="badge bg-success d-inline-flex align-items-center me-2">
                                                    <i className="fe fe-check me-1" />
                                                    Active
                                                </span>
                                            }
                                            {Data.status == 0 &&
                                                <span className="badge bg-danger d-inline-flex align-items-center me-2">
                                                    <i className="fe fe-check me-1" />
                                                    Inactive
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="plane-basic-info plane-detail">
                                    <div className="row">
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Name</h6>
                                                <p>{Data.name}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Blood Group</h6>
                                                <p>{Data.blood_group}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Mobile No</h6>
                                                <p><a
    href={`tel:${Data.mobile}`}     /* or your own button classes */
    style={{ textDecoration: "none" }} /* remove underline */
  >
    {Data.mobile}
  </a></p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6> password</h6>
                                                <p>{Data.password}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6> Employee Type</h6>
                                                <p>{Data.emp_type}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Date Of Birth</h6>
                                                <p>{formatSimpleDate(Data.date_of_birth)}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>User Type</h6>
                                                <p>{Data.user_type}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Date Of Joining</h6>
                                                <p>{formatSimpleDate(Data.doj)}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Emergency Contact Name</h6>
                                                <p>{Data.con_person}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Emergency Contact Number</h6>
                                                <p><a
                                                    href={`tel:${Data.cont_no}`}     /* or your own button classes */
                                                    style={{ textDecoration: "none" }} /* remove underline */
                                                >
                                                    {Data.cont_no}
                                                </a></p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Salary</h6>
                                                <p>{Data.salary}</p>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Shift In</h6>
                                                <p>{formatTimeTo12Hour(Data.shift_in)}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Shift Out</h6>
                                                <p>{formatTimeTo12Hour(Data.shift_out)}</p>
                                            </div>
                                        </div> */}
                                       
                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

EmployeeView.propTypes = {
    Emp_data: PropTypes.object.isRequired,
};

export default EmployeeView;

